import {
  DELETE_GROUP_MEMBER_ERROR,
  DELETE_GROUP_MEMBER_START,
  DELETE_GROUP_MEMBER_SUCCESS,
} from 'constants/action-types/organizations/deleteGroupMember';

export default (state, { type, payload }) => {
  switch (type) {
    case DELETE_GROUP_MEMBER_START:
      return {
        ...state,
        deleteGroupMember: {
          ...state.deleteGroupMember,
          loading: true,
          error: null,
          message: null,
        },
      };
    case DELETE_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        deleteGroupMember: {
          ...state.deleteGroupMember,
          loading: false,
          error: null,
          message: payload.data,
        },
      };
    case DELETE_GROUP_MEMBER_ERROR:
      return {
        ...state,
        deleteGroupMember: {
          ...state.deleteGroupMember,
          loading: false,
          message: null,
          error: payload,
        },
      };
    default:
      return null;
  }
};
